import { useEffect, useState } from "react";
import { LeaveAPI } from "../../api/leave";

export default function AdminLeavePage() {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  async function loadData() {
    try {
      setLoading(true);
      const data = await LeaveAPI.listAllRequests();
      setRequests(Array.isArray(data) ? data : []);
      setError("");
    } catch (err) {
      setError(err.message || "Failed to load leave requests");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    loadData();
  }, []);

  async function handleApprove(id) {
    try {
      await LeaveAPI.approveRequest(id);
      await loadData();
    } catch (err) {
      setError(err.message || "Failed to approve leave request");
    }
  }

  async function handleReject(id) {
    const rejection_reason = window.prompt("Rejection reason:", "") || "";

    try {
      await LeaveAPI.rejectRequest(id, rejection_reason);
      await loadData();
    } catch (err) {
      setError(err.message || "Failed to reject leave request");
    }
  }

  async function handleCancel(id) {
    if (!window.confirm("Cancel this leave request?")) return;

    try {
      await LeaveAPI.cancelRequest(id);
      await loadData();
    } catch (err) {
      setError(err.message || "Failed to cancel leave request");
    }
  }

  if (loading) {
    return <div className="p-4">Loading leave requests…</div>;
  }

  return (
    <div className="p-4 space-y-6">
      <div>
        <h1 className="text-2xl font-semibold">Leave Requests</h1>
        <p className="text-sm text-gray-600 mt-1">
          Approve, reject, and manage leave requests.
        </p>
      </div>

      {error ? (
        <div className="border border-red-200 bg-red-50 text-red-700 rounded p-3 text-sm">
          {error}
        </div>
      ) : null}

      <div className="border rounded bg-white p-4">
        {requests.length === 0 ? (
          <div className="text-sm text-gray-500">No leave requests found.</div>
        ) : (
          <div className="space-y-3">
            {requests.map((request) => (
              <div key={request.id} className="border rounded p-3">
                <div className="flex items-start justify-between gap-4">
                  <div>
                    <div className="font-medium">
                      {request.user_name} — {request.leave_type_name}
                    </div>
                    <div className="text-sm text-gray-600 mt-1">
                      {request.is_all_day ? (
                        <>
                          All day: {new Date(request.start_at).toLocaleDateString()}{" "}
                          {new Date(request.start_at).toDateString() !==
                          new Date(request.end_at).toDateString()
                            ? `→ ${new Date(request.end_at).toLocaleDateString()}`
                            : ""}
                        </>
                      ) : (
                        <>
                          {new Date(request.start_at).toLocaleString()} →{" "}
                          {new Date(request.end_at).toLocaleString()}
                        </>
                      )}
                    </div>
                    <div className="text-sm text-gray-600 mt-1">
                      Status: {request.status}
                    </div>
                    {request.notes ? (
                      <div className="text-sm text-gray-600 mt-1">
                        Notes: {request.notes}
                      </div>
                    ) : null}
                    {request.rejection_reason ? (
                      <div className="text-sm text-red-600 mt-1">
                        Rejection reason: {request.rejection_reason}
                      </div>
                    ) : null}
                  </div>

                  <div className="flex gap-2">
                    {request.status === "pending" ? (
                      <>
                        <button
                          className="px-3 py-1 rounded bg-green-600 text-white"
                          onClick={() => handleApprove(request.id)}
                        >
                          Approve
                        </button>
                        <button
                          className="px-3 py-1 rounded bg-red-600 text-white"
                          onClick={() => handleReject(request.id)}
                        >
                          Reject
                        </button>
                      </>
                    ) : null}

                    {request.status !== "cancelled" ? (
                      <button
                        className="px-3 py-1 rounded bg-gray-200"
                        onClick={() => handleCancel(request.id)}
                      >
                        Cancel
                      </button>
                    ) : null}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}